var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Cliente (nome ou número de celular)"},on:{"input":_vm.change},model:{value:(_vm.client),callback:function ($$v) {_vm.client=$$v},expression:"client"}})}
var staticRenderFns = []

export { render, staticRenderFns }